// extracted by mini-css-extract-plugin
export var addButton = "_5i-d";
export var bullets = "_5i-e";
export var compact = "_5i-2";
export var container = "_5i-j";
export var extendedWarrantyModal = "_5i-f";
export var learn = "_5i-l";
export var learnMore = "_5i-g";
export var offeringOption = "_5i-3";
export var offeringPrice = "_5i-8";
export var offeringSubtitle = "_5i-7";
export var offeringTitle = "_5i-6";
export var offeringsContainer = "_5i-0";
export var pdpTilesBackground = "_5i-n";
export var plan = "_5i-m";
export var regular = "_5i-1";
export var remove = "_5i-k";
export var seeDetailsIcon = "_5i-i";
export var seeDetailsLink = "_5i-h";
export var selectedOption = "_5i-4";
export var shieldIcon = "_5i-b";
export var shieldIconCompact = "_5i-c";
export var subtitle = "_5i-a";
export var title = "_5i-9";
export var unselectedOption = "_5i-5";